module.exports = __webpack_public_path__ + "img/rascrut-8.2c926273.jpg";